function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 14,
    viewBox: "0 0 37 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 0h25.218a8 8 0 017.753 6.027l1.395 5.48A2 2 0 0134.427 14H1a1 1 0 01-1-1V2a2 2 0 012-2zm1 2a1 1 0 00-1 1v4h6V2H3zm7 0v5h6V2h-6zm8 0v5h6V2h-6zm8 0v5h7l-.122-.48C32.201 3.861 29.962 2 27.218 2H26z",
    fill: "#23B15E",
    fillRule: "evenodd"
  }));
}

export var ReactComponent = SvgComponent;
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/occupancy/ic-train-head.svg";